<template>
  <div>
    <HomeBanner></HomeBanner>
    <div class="home_simple">
      <div class="row" id="fade_div">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
          <div class="left">
            <div>
              <p class="num">{{ List[0].yearNum }}</p>
              <p class="title">{{ List[0].title }}</p>
              <p class="simple">
                {{ List[0].content }}
              </p>
              <p class="litter_line"></p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
          <div class="right">
            <img :src="List[0].img" />
          </div>
        </div>
      </div>
    </div>

    <div
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
      data-aos-id="super-duper"
      class="row simple_mid"
    >
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
        <div class="simple_more" @click="scrollNavto('/Brand', 'brand')">
          <p>了解更多</p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10">
        <div class="row" id="num">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <span class="simple_num">
              <!-- <count-to ref="mynum" :start-val='0' :end-val='List[0].yearNum' :duration='3000'></count-to> -->
            <p class="simple_tv">公司成立于</p>
              <countTo
                ref="mynum"
                :startVal="0"
                :endVal="Number(List[0].yearNum)"
                :duration="3000"
                :separator="null"
                :autoplay="false"
              ></countTo> </span
            ><span class="simple_tv">年</span>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <span class="simple_num">
              <!-- <count-to ref="mynum1" :start-val='0' :end-val='List[0].brandNum' :duration='3000'></count-to> -->
            <p class="simple_tv">拥有自主品牌</p>
              <countTo
                ref="mynum1"
                :startVal="0"
                :endVal="Number(List[0].brandNum)"
                :duration="3000"
                :autoplay="false"
              ></countTo> </span
            ><span class="simple_tv">个</span>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <span class="simple_num">
              <!-- <count-to ref="mynum2" :start-val='0' :end-val='List[0].productsNum' :duration='3000'></count-to> -->
            <p class="simple_tv">产品多达</p>
              <countTo
                ref="mynum2"
                :startVal="0"
                :endVal="Number(List[0].productsNum)"
                :duration="3000"
                :autoplay="false"
              ></countTo> </span
            ><span class="simple_tv">余种</span>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <span class="simple_num">
              <!-- <count-to ref="mynum3" :start-val='0' :end-val='List[0].customerNum' :duration='3000'></count-to> -->
            <p class="simple_tv">服务分销商</p>
              <countTo
                ref="mynum3"
                :startVal="0"
                :endVal="Number(List[0].customerNum)"
                :duration="3000"
                :autoplay="false"
              ></countTo> </span
            ><span class="simple_tv">余家</span>
          </div>
        </div>
      </div>
    </div>
    <div
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
      data-aos-id="super-duper"
      class="row simple_brand"
    >
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
        <p>旗下自主品牌</p>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10">
        <div class="my_brand_div">
          <div
            class="my_brand_item"
            v-for="(item, index) in MyBrandList"
            :key="index"
          >
            <img :src="item.img" />
          </div>
        </div>
      </div>
    </div>

    <div class="product_div">
      <p class="title">PRODUCTS CENTER</p>
      <p class="subtitle">产&emsp;品&emsp;展&emsp;示</p>

      <div
        data-aos="fade-up"
        data-aos-anchor-placement="top-bottom"
        class="row"
      >
        <div
          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
          v-for="(item, index) in ProductList"
          :key="index"
        >
          <div class="product_item_div">
            <div class="product_item">
              <img :src="item.banner" />
              <div class="product_hover">
                <p>{{ item.titleCn }}</p>
                <div class="product_line"></div>
                <img class="product_img" :src="item.midImg" />
                <img class="product_img_phone" :src="item.midPhoneImg" />
                <p class="product_item_more" @click="scrollNavtoProduct(index)">
                  查 看 更 多
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="support_div">
      <p class="title">SERVICE & SUPPORT</p>
      <p class="subtitle">服&emsp;务&emsp;与&emsp;支&emsp;持</p>

      <div class="row">
        <div
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
          v-for="(item, index) in SupportList"
          :key="index"
        >
          <div class="support_item_div">
            <div class="support_item">
              <div
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
                class="support_item"
              >
                <div class="img_div">
                  <img :src="item.img" />
                  <div class="img_title">
                    <p class="left_line"></p>
                    <p>{{ item.title }}</p>
                    <p class="left_line"></p>
                  </div>
                </div>
                <div class="hover_div">
                  <p class="title">{{ item.title }}</p>
                  <p class="line"></p>
                  <p class="sub">{{ item.content }}</p>
                  <p class="sub">{{ item.contentSub }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeBanner from "./HomeBanner";
import countTo from "vue-count-to";
export default {
  data() {
    return {
      canScroll: true,
      MyBrandList: [
        {
          img: "",
        },
      ],
      List: [
        {
          brandNum: "",
          content: "",
          customerNum: "",
          img: "",
          productsNum: "",
          title: "",
          yearNum: "",
        },
      ],
      ProductList: [
        {
          banner: "",
          cover: "",
          midImg: "",
          midPhoneImg: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
      ],
      SupportList: [
        {
          title: "",
          content: "",
          contentSub: "",
          img: "",
        },
      ],
      background_img: "../static/img/首页-产品展示-标注8-1A.jpg",
    };
  },
  components: {
    HomeBanner,
    countTo,
  },
  mounted() {
    this.Init();
    setTimeout(() => {
      this.addAnimatedIn();
    }, 1000);
  },
  created() {
    // window.addEventListener("onmessageWS", this.addAnimatedIn);
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.windowScrollListener);
  },
  updated() {
    setTimeout(() => {
      // Aos.init({
      //   duration: 1000,
      // });
      this.addAnimatedIn();
    }, 2000);
  },
  methods: {
    Init() {
      this.getSimple();
      this.getSupport();
      this.getProduct();
      this.getMyBrand();
      window.addEventListener("scroll", this.windowScrollListener);
    },
    scrollNavtoProduct(index) {
      console.log(index);
      var name = "";
      if (index == 0) {
        var name = "bathroom";
      } else if (index == 1) {
        var name = "valve";
      } else if (index == 2) {
        var name = "water";
      } else if (index == 3) {
        var name = "hvac";
      }
      this.$router.push({
        path: `/Products`,
        query: { param: name },
      });
    },
    windowScrollListener() {
      // 获取滚动条的高度
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      var width = document.documentElement.clientWidth;
      console.log("scrollTop=" + scrollTop);
      var limitScroll = 600;
      if(width<1000){//手机端
        limitScroll = 10;
      }else{
        limitScroll = 600;

      }
      if (scrollTop > limitScroll) {
        // 利用布尔值控制元素的显隐
        if (this.canScroll) {
          this.canScroll = false;
          this.handleScroll();
          console.log("startScroll=" + scrollTop);
        }
      }
      if (scrollTop < 100) {
        // this.canScroll = true;
        console.log("resetScroll=" + scrollTop);
      }
    },
    addAnimatedIn() {
      console.log("animated init");
      // document
      //   .getElementById("#fade_div")
      //   .addEventListener("aos:in", ({ detail }) => {
      //     console.log("animated in", detail);
      //   });

      // document
      //   .getElementById("#fade_div")
      //   .addEventListener("aos:out", ({ detail }) => {
      //     console.log("animated out", detail);
      //   });
    },
    getSimple() {
      let that = this;
      this.$axios
        .get("app/homecompany/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.List = response.data.page.list;
            // this.handleScroll();
            // console.log(that.List);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getSupport() {
      let that = this;
      this.$axios
        .get("app/supportpager/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.SupportList = response.data.page.list;
            // console.log(that.SupportList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getMyBrand() {
      let that = this;
      this.$axios
        .get("app/mybrand/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.MyBrandList = response.data.page.list;
            // console.log(that.MyBrandList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getProduct() {
      let that = this;
      this.$axios
        .get("app/producttype/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.ProductList = response.data.page.list;
            // console.log(that.ProductList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    handleScroll() {
      // this.$refs.mynum.reset();
      this.$refs.mynum.start();
      this.$refs.mynum1.start();
      this.$refs.mynum2.start();
      this.$refs.mynum3.start();
    },
    scrollNavto(path, name) {
      this.$router.push({
        path: `${path}`,
        query: { param: name },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.home_simple {
  margin: 10rem auto 0;
  display: flex;
  width: 90%;
  text-align: center;
  justify-self: center;

  .left {
    text-align: start;
    height: 50rem;

    // width: 35%;
    div {
      height: 100%;
      position: relative;
    }

    .num {
      font-size: 30rem;
      color: var(--textGaryColor);
      font-family: bin_num_din;
      line-height: 20rem;
    }

    .title {
      color: var(--textBlueColor);
      font-family: bold;
      font-size: 4rem;
      margin-top: 4rem;
    }

    .simple {
      margin-top: 2rem;
      // color:var(--textBlueColor);
      font-family: thin;
      font-size: 1.8rem;
      line-height: 3rem;
    }
  }

  .right {
    height: 50rem;
    margin-left: 10rem;
    // width: 65%;
    position: relative;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      position: absolute;
      right: 0;
    }
  }

  .litter_line {
    box-sizing: border-box;
    background-color: black;
    height: 1px;
    width: 100%;
    position: absolute;
    bottom: 0;
    margin: 0;
  }
}

.simple_mid {
  margin: 8rem auto 8rem;
  width: 90%;
  text-align: center;
  justify-self: center;

  .simple_more {
    margin-left: -15px;
    height: 10rem;
    position: relative;
    justify-content: center;
    color: var(--textWhiteColor);
    font-size: 1.8rem;
    font-family: light;

    p {
      cursor: pointer;
      margin: auto;
      top: 25%;
      position: absolute;
      background: var(--textBlueColor);
      width: 80%;
      padding: 2rem 2rem;
      text-align: center;
    }
  }

  .simple_num {
    color: var(--textBlueColor);
    font-size: 10rem;
    font-family: bin_num_din;
    line-height :1;
  }

  .simple_tv {
    margin-left: 1rem;
    color: var(--textBlackColor);
    font-size: 1.8rem;
    font-family: light;
  }
}

.simple_brand {
  margin: 1rem auto 8rem;
  width: 90%;
  text-align: center;
  justify-self: center;
  border-top: 1px solid var(--textBlackColor);
  padding-top: 5rem;

  p {
    text-align: left;
    padding: 0;
    margin-left: -15px;
    font-size: 2.4rem;
    height: 8rem;
    line-height: 8rem;
  }
}

.my_brand_div {
  margin:0 -15px;
  display: flex;
  justify-content: space-between;

  .my_brand_item {
    height: 8rem;
    width: auto;

    img {
      height: 100%;
      width: auto;
      object-fit: contain;
    }
  }
}

.product_div {
  padding: 0 8rem;
  background: var(--textBlueColor);

  .title {
    color: var(--textWhiteColor20);
    font-size: 10rem;
    font-family: bin_num_din;
  }

  .subtitle {
    margin-top: -6rem;
    color: var(--textWhiteColor);
    font-size: 4.8rem;
    font-family: medium;
  }
}

.support_div {
  padding: 0 8rem;
  background: var(--textWhiteColor);

  .title {
    color: var(--textBlueColor20);
    font-size: 10rem;
    font-family: bin_num_din;
  }

  .subtitle {
    margin-top: -6rem;
    color: var(--textBlueColor);
    font-size: 4.8rem;
    font-family: medium;
  }
}

.product_item_div {
  margin: 6rem auto 10rem;
  width: 36rem;
  height: 48rem;
  overflow: hidden;
}

.product_item {
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.product_hover {
  padding: 3rem 0;
  margin-top: -10rem;
  width: 100%;
  height: 100%;
  transition: all 0.6s ease 0s;
  color: var(--textWhiteColor);
  font-size: 2rem;
  font-family: regular;
  display: inline-block;
  background: -webkit-linear-gradient(#00000000, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#00000000, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#00000000, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC); /* Firefox 3.6 - 15 */
  background: linear-gradient(#00000000, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC, #000000CC); /* 标准的语法（必须放在最后） */

  .product_line {
    display: inline-block;
    margin: 1rem auto 4rem;
    background-color: var(--textWhiteColor);
    height: 2px;
    width: 2.1rem;
  }

  .product_img_phone {
    display: none;
  }

  .product_img {
    width: 18rem;
    height: 18rem;
    display: block;
    margin: 0 auto 4rem;
  }

  .product_item_more {
    cursor: pointer;
    border: 1px solid var(--textWhiteColor);
    font-size: 1.6rem;
    font-family: cnlight;
    width: fit-content;
    margin: auto;
    padding: 0.8rem 2rem;
  }
}

.product_item:hover .product_hover {
  transform: translateY(-38rem);
  transition: all 0.6s ease 0s;
  -webkit-transform: translateY(-38rem);
  font-size: 2.4rem;
  background: -webkit-linear-gradient(#000000CC, #000000CC); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#000000CC, #000000CC); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#000000CC, #000000CC); /* Firefox 3.6 - 15 */
  background: linear-gradient(#000000CC, #000000CC); /* 标准的语法（必须放在最后） */
}

.support_item_div {
  margin: 6rem auto 10rem;
  width: 48rem;
  height: 28rem;
  overflow: hidden;
}

.support_item {
  width: 48rem;
  height: 28rem;
  overflow: hidden;

  .hover_div {
    // display: none;
  }

  img {
    width: 100%;
  }

  .img_div {
    position: relative;
    width: 48rem;
    height: 28rem;

    .img_title {
      bottom: 2rem;
      width: 100%;
      position: absolute;
      padding: 1rem;
      align-content: center;
      align-items: center;
      justify-content: center;
      display: flex;
      background-color: #0071ceCC;
      color: white;
      font-size: 2rem;
      font-family: regular;

      .left_line {
        margin: 0 1rem;
        background-color: var(--textWhiteColor);
        box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.4);
        height: 1px;
        width: 10%;
      }
    }
  }

  .hover_div {
    width: 48rem;
    height: 28rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    // width: 100%;
    // height: 100%;
    background-color: #0071ceCC;
    color: white;
    font-size: 2rem;
    font-family: regular;

    .title {
      font-size: 2.4rem;
      color: white;
    }

    .line {
      margin: 2rem auto 10rem;
      background-color: var(--textWhiteColor);
      height: 1px;
      width: 2.5rem;
    }

    .sub {
      font-size: 1.6rem;
      line-height: 2.4rem;
      font-family: light;
    }
  }

  .hover_div {
    transition: all 0.4s ease 0s;
  }

  .support_item:hover .hover_div {
    // position: absolute;
    // height: 100%;
    // width: 100%;
    // top: 0;
    // left: 0;
    transform: translateY(-100%);
    transition: all 0.4s ease 0s;
    -webkit-transform: translateY(-100%);
  }

  // .support_item:hover img {
  // transform: scale(1.3);
  // transition: all 0.4s ease 0s;
  // -webkit-transform: scale(1.3);
  // }
  .support_item:hover .img_title {
    display: none;
  }
}

@media screen and (max-width: 1200px) {
  .simple_brand {
    p{
      text-align :center;
    }
  }
  .my_brand_div {

    .my_brand_item {
      height: 3rem;
    }
  }

  #fade_div {
    display: flex;
    flex-direction: column-reverse;
  }

  .home_simple {
    margin: 3rem auto 0;

    .right {
      margin: 0;
      height: 20rem;
    }

    .num {
      display: none;
    }

    .left {
      height: auto;

      .title {
        line-height: 3rem;
        margin-top: 2rem;
        font-size: 3rem;
      }
    }

    .simple {
      margin-top: 1rem !important;
      padding-bottom: 2rem;
    }
  }

  .simple_mid {
    margin: 4rem auto 0;
    display: flex;
    flex-direction: column-reverse;

    #num, div {
      padding: 0;
    }

    .simple_num {
      font-size: 4rem;
    }

    .simple_tv {
      font-size: 1rem;
      margin: 0;
    }

    .simple_more {
      height: 10rem;
      margin-left: 0;

      p {
        width: 100%;
        padding: 1rem;
      }
    }
  }

  .product_div {
    padding: 0 2rem;

    .title {
      font-size: 5rem;
    }

    .subtitle {
      margin-top: -4rem;
      font-size: 3rem;
    }
  }

  .product_item_div {
    width: 100%;
    margin: 2rem 0;
    height: 20rem;
  }

  .product_item {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .product_hover {
    padding: 1rem 0;
    font-size: 1.6rem;
    width: 100%;
    height: 100%;
    margin-top: -6rem;

    .product_line {
      margin: 1rem auto 1rem;
    }

    .product_img_phone {
      margin: auto;
      display: block;
      width: 90%;
      height: 7rem;
      object-fit: scale-down;
    }

    .product_img {
      display: none;
    }

    .product_item_more {
      width: 90%;
      margin: 1rem auto 0;
    }
  }

  .product_item:hover .product_hover {
    transform: translateY(-14rem);
    -webkit-transform: translateY(-14rem);
    font-size: 2rem;
  }

  .support_div {
    padding: 0 2rem;

    .title {
      font-size: 5rem;
    }

    .subtitle {
      margin-top: -4rem;
      font-size: 3rem;
    }
  }

  .support_item_div {
    width: 100%;
    margin: 2rem 0;
    height: 20rem;
  }

  .support_item {
    width: 100%;
    height: 100%;

    .img_div {
      width: 100%;
      height: 100%;

      .img_title {
        padding: 0.5rem;
        font-size: 1.8rem;
      }
    }

    .hover_div {
      width: 100%;
      height: 100%;

      .line {
        margin: 2rem auto 5rem;
      }

      .title {
        font-size: 2rem;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
